import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  FileDescriptor,
  ProjectDescriptor,
} from '../../elements/resource/types/shape.type';
import { Observable } from 'rxjs';
import {
  selectCurrentFileDescriptorByKey,
  selectCurrentFileDescritor,
  selectCurrentProjectDescriptor,
  selectCurrentProjectDescriptorKey,
} from '../../element-editor/store/selector/editor.selector';
import {
  saveProjectDescriptorByKey,
  setCompleteCurrentFileDescriptor,
  setCompleteProjectDescriptor,
  setFileDescriptorItem,
} from '../../element-editor/store/editor.actions';

@Component({
  selector: 'nw-file-project-settings',
  templateUrl: './file-project-settings.component.html',
  styleUrls: ['./file-project-settings.component.scss'],
})
export class FileProjectSettingsComponent implements OnInit, OnDestroy {
  @Input() fileKey?: keyof FileDescriptor;

  @Input() completeFile: boolean;
  @Input() completeProject: boolean;

  @Input() projectKey?: keyof ProjectDescriptor;
  @Input() label: string;

  // UI state mirrored from current file-project definition
  // JSON editor modal visibility
  showJsonEditor = false;

  // Custom ellipse file-project state
  openJsonEditor() {
    this.showJsonEditor = true;
  }

  onJsonClose() {
    this.showJsonEditor = false;
  }
  currentJSON$: Observable<any>;

  currentJSON: any;
  constructor(private readonly store: Store) {}

  ngOnInit() {
    if (this.projectKey) {
      this.currentJSON$ = this.store.select(
        selectCurrentProjectDescriptorKey(this.projectKey),
      );
    }

    if (this.fileKey) {
      this.currentJSON$ = this.store.select(
        selectCurrentFileDescriptorByKey(this.fileKey),
      );
    }

    if (this.completeFile) {
      this.currentJSON$ = this.store.select(selectCurrentFileDescritor);
    }

    if (this.completeProject) {
      this.currentJSON$ = this.store.select(selectCurrentProjectDescriptor);
    }

    this.currentJSON$.subscribe(val => {
      // console.log('currentJSON', val);
      this.currentJSON = val;
    });
  }

  selectProjectBg(id: string) {}

  save(value) {
    // -- //
    this.showJsonEditor = false;
    console.log('Save', this.currentJSON);
    if (this.projectKey) {
      console.log(
        'save - projectKey',
        this.projectKey,
        'this._currentJSON',
        this.currentJSON,
      );
      this.store.dispatch(
        saveProjectDescriptorByKey({
          key: this.projectKey,
          value,
        }),
      );
    }

    // -- // -- //

    if (this.fileKey) {
      console.log(
        'save - fileKey',
        this.fileKey,
        'this._currentJSON',
        this.currentJSON,
      );
      this.store.dispatch(
        setFileDescriptorItem({
          key: this.fileKey,
          value,
        }),
      );
    }

    if (this.completeFile) {
      this.store.dispatch(
        setCompleteCurrentFileDescriptor({
          descriptor: value,
        }),
      );
    }

    if (this.completeProject) {
      this.store.dispatch(
        setCompleteProjectDescriptor({
          descriptor: value,
        }),
      );
    }
  }
  ngOnDestroy(): void {
    // this.subs.unsubscribe(); //
  }
}
